const addUTMSource = (href: string) => {
  try {
    const url = new URL(href);
    url.searchParams.set('utm_source', 'fashionunited');

    return url.href;
  } catch {
    return href;
  }
};

export default addUTMSource;
